import createRoute  from '@widesk-ui/tools/createRoute';
import PartnerModel from '@models/website/PartnerModel';

const route = createRoute.splitView(
	'configuration/partners',
	'website',
	'PartnerSplitView',
	PartnerModel.localize('plural'),
);
export default route;
